import React, { useState } from "react";

import grennlandImage1 from "../../assets/blogs/greenland.jpg";
import grennlandImage2 from "../../assets/projects/galary2.jpeg";
import grennlandImage3 from "../../assets/projects/gl-banner3.jpg";
import softProthidin from "../../assets/projects/soft-prothidin.png";
import softKsa from "../../assets/projects/ksa.png";
import softGlobal from "../../assets/projects/Global.png";
import softHajj from "../../assets/projects/hajj.jpeg";
import digiPen from "../../assets/projects/digitalPen.jpg";
import digiMog from "../../assets/projects/digiMog.jpg";
import iconicandbulders from "../../assets/projects/iconic and bulders.jpeg";

const projectsData = [
  // ================= ICONIC GREENLAND =================
  {
    id: 1,
    concern: "Iconic Greenland",
    title: "Iconic Greenland Residential Project",
    type: "Residential",
    location: "Sanarpar, Demra, Dhaka",
    description:
      "A modern residential development designed to provide comfortable living spaces with quality construction and essential facilities.",
    image: grennlandImage1,
  },
  {
    id: 2,
    concern: "Iconic Greenland",
    title: "Greenland Land Development",
    type: "Land Development",
    location: "Dhaka, Bangladesh",
    description:
      "A planned land development project focused on organized residential plots, accessibility and suitable infrastructure.",
    image: grennlandImage2,
  },
  {
    id: 3,
    concern: "Iconic Greenland",
    title: "Greenland Apartment Project",
    type: "Apartment",
    location: "Dhaka, Bangladesh",
    description:
      "Residential apartment development focused on modern design, practical living spaces and a comfortable community environment.",
    image: grennlandImage3,
  },
  {
    id: 4,
    concern: "Iconic Greenland",
    title: "Iconic City Begins: Historic Partnership",
    type: "Partnership",
    location: "Bangladesh",
    description:
      "Iconic City officially began its journey when Iconic Greenland Ltd. joined hands with Our Builder Ltd. through a formal signing ceremony, marking the beginning of a strategic partnership for a sustainable future.",
    image: iconicandbulders,
  },

  // ================= ICONIC SOFT =================
  {
    id: 5,
    concern: "Iconic Soft",
    title: "Protidin Sokal",
    type: "Software",
    location: "Bangladesh",
    description:
      "A business management solution designed to simplify daily operations, manage information and improve organizational efficiency.",
    image: softProthidin,
  },
  {
    id: 6,
    concern: "Iconic Soft",
    title: "BD Iconic Company",
    type: "Enterprise Software",
    location: "Bangladesh",
    description:
      "A scalable software platform developed to support business processes, management and operational workflows.",
    image: softKsa,
  },
  {
    id: 7,
    concern: "Iconic Soft",
    title: "Iconic Global Travels Ltd",
    type: "Custom Software",
    location: "Bangladesh",
    description:
      "Custom software solutions developed according to specific business requirements and operational needs.",
    image: softGlobal,
  },
  {
    id: 8,
    concern: "Iconic Soft",
    title: "Iconic Hajj Group",
    type: "Custom Software",
    location: "Bangladesh",
    description:
      "Custom software solutions developed according to specific business requirements and operational needs.",
    image: softHajj,
  },

  // ================= ICONIC DIGITAL SOLUTIONS =================
  {
    id: 9,
    concern: "Iconic Digital Solutions",
    title: "Pen Design",
    type: "Web Development",
    location: "Bangladesh",
    description:
      "Modern corporate website designed to establish a professional digital presence and showcase business services.",
    image: digiPen,
  },
  {
    id: 10,
    concern: "Iconic Digital Solutions",
    title: "Mog Design",
    type: "Web Application",
    location: "Bangladesh",
    description:
      "A modern e-commerce platform designed for product management, online sales, customer management and business operations.",
    image: digiMog,
  },
];

const OurProjects = () => {
  const [visibleCount, setVisibleCount] = useState(4);

  const handleShowMore = () => {
    setVisibleCount((prev) => Math.min(prev + 4, projectsData.length));
  };

  const handleShowLess = () => {
    setVisibleCount(4);
  };

  return (
    <section
      style={{
        padding: "30px 20px",
        backgroundColor: "#ffffff",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* ================= HEADER ================= */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontSize: "35px",
              fontWeight: "bold",
              color: "#bd06d3",
              textTransform: "uppercase",
              letterSpacing: "1px",
              margin: 0,
            }}
          >
            Our <span style={{ color: "#00bfff" }}>Projects</span>
          </h2>

          <p
            style={{
              maxWidth: "600px",
              margin: "12px auto 0",
              color: "#64748b",
              fontSize: "14px",
              lineHeight: 1.7,
            }}
          >
            Explore selected projects delivered through our property, software
            and digital solution businesses.
          </p>
        </div>

        {/* ================= PROJECT GRID ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "24px",
          }}
        >
          {projectsData.slice(0, visibleCount).map((project) => (
            <div
              key={project.id}
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "10px",
                overflow: "hidden",
                border: "1px solid rgba(189, 6, 179, 0.12)",
                boxShadow: "0 3px 12px rgba(15, 23, 42, 0.05)",
              }}
            >
              {/* Image */}
              <div
                style={{
                  width: "100%",
                  height: "200px",
                  overflow: "hidden",
                  backgroundColor: "#f8fafc",
                }}
              >
                <img
                  src={project.image}
                  alt={project.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>

              {/* Content */}
              <div
                style={{
                  padding: "18px",
                }}
              >
                {/* Concern */}
                <p
                  style={{
                    margin: "0 0 7px",
                    color: "#00bfff",
                    fontSize: "11px",
                    fontWeight: 600,
                  }}
                >
                  {project.concern}
                </p>

                {/* Title */}
                <h3
                  style={{
                    margin: "0 0 8px",
                    color: "#bd06d3",
                    fontSize: "18px",
                    fontWeight: 700,
                    lineHeight: 1.4,
                  }}
                >
                  {project.title}
                </h3>

                {/* Type */}
                <p
                  style={{
                    margin: "0 0 8px",
                    color: "#475569",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {project.type}
                </p>

                {/* Location */}
                <p
                  style={{
                    margin: "0 0 10px",
                    color: "#64748b",
                    fontSize: "12px",
                  }}
                >
                  📍 {project.location}
                </p>

                {/* Description */}
                <p
                  style={{
                    margin: 0,
                    color: "#64748b",
                    fontSize: "13px",
                    lineHeight: 1.6,
                  }}
                >
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* ================= SHOW MORE ================= */}
        {projectsData.length > 6 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "35px",
            }}
          >
            {visibleCount < projectsData.length ? (
              <button
                type="button"
                onClick={handleShowMore}
                style={{
                  padding: "10px 22px",
                  borderRadius: "6px",
                  border: "1px solid #bd06d3",
                  backgroundColor: "#ffffff",
                  color: "#bd06d3",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Show More Projects
              </button>
            ) : (
              <button
                type="button"
                onClick={handleShowLess}
                style={{
                  padding: "10px 22px",
                  borderRadius: "6px",
                  border: "1px solid #bd06d3",
                  backgroundColor: "#ffffff",
                  color: "#bd06d3",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Show Less
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default OurProjects;
